(function ($, Drupal) {

  "use strict";

  Drupal.behaviors.fundChart = {
    attach: function (context, settings) {
      const $charts = $('.chart', context);
      const $window = $(window);

      // No charts if Highcharts is not available.
      if (typeof Highcharts === 'undefined') {
        return;
      }

      Highcharts.setOptions({
        lang: {
          thousandsSep: ','
        },
      });

      $(once('Highcharts', $charts)).each(function () {
        const config = $(this).data().config;

        if (config) {

          // Build series.
          let series = [];
          $.each(config.data, function (key, data) {
            series.push({
              type: 'area',
              name: config.fund,
              lineColor: '#013974',
              color: '#2C5A8D',
              fillOpacity: 0.5,
              data: data.values,
              visible: key === 0,
            });
          });

          const chart = Highcharts.chart(config.id, {
            chart: {
              zoomType: 'x'
            },
            credits: {
              enabled: false
            },
            title: {
              text: config.title,
            },
            xAxis: {
              type: 'datetime',
              title: {
                text: '',
              },
              labels: {
                formatter: function () {
                  const format = (this.isFirst || this.isLast) ? '%m/%e/%y' : '%m/%y';
                  const date = (this.value - 24 * 60 * 3600);
                  return Highcharts.dateFormat(format, date);
                },
              },
              showFirstLabel: true,
              showLastLabel: true,
              endOnTick: true,
            },
            yAxis: {
              title: {
                text: '',
              },
              labels: {
                formatter: function () {
                  return '$ ' + Highcharts.numberFormat(this.value, 0);
                },
              },
            },
            legend: {
              enabled: false
            },
            plotOptions: {
              area: {
                fillColor: {
                  linearGradient: {
                    x1: 0,
                    y1: 0,
                    x2: 0,
                    y2: 1
                  },
                  stops: [
                    [0, '#2C5A8D'],
                    [1, '#ACB5D2'],
                  ]
                },
                marker: {
                  radius: 2
                },
                lineWidth: 2,
                states: {
                  hover: {
                    lineWidth: 1
                  }
                },
                threshold: null,
              }
            },
            tooltip: {
              padding: 8,
              style: {
                color: '#2C5A8D',
                fontSize: '18px',
              },
              useHTML: true,
              formatter: function() {
                return `<p style="text-align: center; margin: 0;"><span style="font-weight: bold">${config.fund}</span> $${Highcharts.numberFormat(this.y, 0)} <br /> <small>(${Highcharts.dateFormat('%m/%e/%y', this.x)})</small></p>`;
              }
            },
            series: series,
          });

          // Series switcher.
          const $switches = $(this).find('.chart__switchers').find('a');
          $switches.each(function () {
            $(this).click(function (event) {
              event.preventDefault();
              const $switch = $(this);

              if ($switch.hasClass('button--disabled')) {
                return false;
              }

              $switches.filter('.is-active').removeClass('is-active');
              $switch.addClass('is-active');

              const key = $(this).data().key;
              $(chart.series).each(function() {
                this.setVisible(false, false);
                chart.series[key].setVisible(true, false);
              });
              chart.redraw();
            });
          });

          // Activate the last chart.
          $switches.last().click();

          // Animate the chart when scrolling.
          chart.redraw();
          $window.scroll(function () {
            chart.redraw();
          });
        }
      });

      // Get URL path
      let pathname = window.location.pathname;

      if (pathname === '/fundx-fundx-conservative-upgrader-relax') {
        // remove RELAX Mnst GlbMkt Lrg-Mid Quarter End.
        $('.tabs__content[data-id="tab-1"] tbody tr:nth-child(2) td').remove();
      }
    }
  };

})(jQuery, Drupal);
